import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { FieldCoreComponent } from "../FieldCoreComponent";

const OFFSET = 2;

@Component({
  selector: "med-textarea",
  templateUrl: "./med-textarea.component.html",
  styleUrls: ["./med-textarea.component.css"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedTextareaComponent),
  }],
})
export class MedTextareaComponent extends FieldCoreComponent<string | number> implements AfterViewInit {
  @Input() role = "textbox";
  @Input() maxHeight = 1000;
  @Input() height = "inherit";
  @Input() autoResize = false;

  @ViewChild("element") element!: ElementRef<HTMLTextAreaElement>;

  onInputTextarea({ target: { value } }: any) {
    this.onInput.emit(value);

    if (!this.autoResize) {
      return;
    }

    const contentHeight = this.element.nativeElement.scrollHeight + OFFSET;
    const height = contentHeight > this.maxHeight ? this.maxHeight : contentHeight;
    this.element.nativeElement.setAttribute("style", `height: ${height}px`);
  }
}
